/* eslint-disable max-len */
const compose = (...fns) => (...args) => fns.reduceRight((res, fn) => [fn.call(null, ...res)], args)[0];

const curry = (fn) => {
	const arity = fn.length;
	return function $curry(...args) {
		if (args.length < arity) {
			return $curry.bind(null, ...args);
		}
		return fn.call(null, ...args);
	};
};

function setNewProperty(property, value) {
	return function p(obj) {
		const newObj = { ...obj };
		newObj[property] = value;
		return newObj;
	};
}

function updateItemInCollection(...args) {
	const [item, matchProperty, propertyToUpdate, value] = [...args];
	const newValue = value === null || value === undefined ? item[propertyToUpdate] : value;
	return function inner(currentItem) {
		let newItem = { ...currentItem };
		if (item[matchProperty] === currentItem[matchProperty]) {
			newItem = setNewProperty(propertyToUpdate, newValue)(newItem);
		}
		return newItem;
	};
}

function getPropertysValue(prop) {
	return function inner(obj) {
		return (obj || {})[prop];
	};
}

function identity(id) {
	return function inner() {
		return id;
	};
}

function minorAnEqualTo(val, prop) {
	return function inner(obj) {
		if (typeof obj === 'object') {
			return val >= obj[prop];
		}
		return val >= obj;
	};
}

function removeItemFromArrayByIndex(index, arr) {
	return arr.reduce((list, item, ind) => {
		const newList = [...list];
		if (index === ind) {
			return newList;
		}
		return newList.concat(item);
	}, []);
}

function removeItemFromArray(prop, propValue) {
	return function inner(arr) {
		const newArr = arr || [];
		return newArr.reduce((list, item) => {
			const newList = [...list];
			if (propValue === item[prop]) {
				return newList;
			}
			return newList.concat(item);
		}, []);
	};
}

function matchWithProperty(prop, val) {
	return function inner(item) {
		if (item[prop] && item[prop] === val) {
			return item;
		}
		return {};
	};
}

function getItemByIndex(index) {
	return function inner(arr) {
		return arr[index] || null;
	};
}

function listByNoMatch(prop, collection) {
	return function inner(list, item) {
		const newList = [...list];
		const exist = !!collection.find((c) => {
			if (typeof c === 'object') {
				return c[prop] === item[prop];
			}
			return c === item[prop];
		});
		if (!exist) {
			return newList.concat(item);
		}
		return newList;
	};
}

/* eslint-disable prefer-const */
function equality(...args) {
	let [prop1, prop2] = args;
	if (!prop2) {
		prop2 = prop1;
	}
	return function inner(item) {
		return item[prop1] === prop2;
	};
}

function createPropertyByOtherOne(...args) {
	const [prop1, prop2] = args;
	return function inner(item) {
		let newItem = null;
		if (item.length) {
			[newItem] = item;
		} else {
			newItem = { ...item };
		}
		newItem[prop1] = getPropertysValue(prop2)(newItem);
		return newItem;
	};
}

function setNewPropertyByFunction(prop, fn, flag = true) {
	return function inner(item, index) {
		if (index === null || index === undefined) {
			if (item.length) {
				const [newItem, newIndex] = item;
				return [setNewProperty(prop, fn(newItem, newIndex))(newItem), newIndex];
			}
			return setNewProperty(prop, fn(item, index))(item);
		}
		if (flag) {
			return [setNewProperty(prop, fn(item, index))(item), index];
		}
		return setNewProperty(prop, fn(item, index))(item);
	};
}

function getDeeper(...args) {
	return function inner(item) {
		let newItem = null;
		if (item.length) {
			[newItem] = item;
		} else {
			newItem = { ...item };
		}
		args.forEach((el) => {
			newItem = (newItem || {})[el];
		});
		return newItem;
	};
}

function getDeepPropertyOf(obj, args) {
	let propVal = { ...obj };
	args.forEach((el) => {
		propVal = propVal[el];
	});
	return function inner() {
		return propVal;
	};
}

function getIndexOf() {
	return function inner(item, index) {
		return index;
	};
}

function validateObject(obj) {
	return obj || {};
}

function reduce(fn, col, acc = []) {
	return col.reduce(fn, acc);
}

function map(fn, col) {
	return col.map(fn);
}

function find(fn, col) {
	return col.find(fn);
}

function forEach(fn, col) {
	return col.forEach(fn);
}

function matchBetweenArrays(collection1, collection2) {
	const [arr1, prop1] = collection1;
	const [arr2, prop2] = collection2;
	let list = [];
	if (prop2) {
		arr1.forEach((a) => {
			const val = prop1 ? a[prop1] : a;
			const match = find(equality(prop2, val), arr2);
			list = list.concat(match);
		});
	}
	return list;
}

function decimals(decimal) {
	return function inner(value) {
		return Math.round(value * (10 ** decimal)) / (10 ** decimal);
	};
}

export default {
	removeItemFromArray,
	removeItemFromArrayByIndex,
	compose,
	curry,
	decimals,
	equality,
	find,
	forEach,
	getDeeper,
	getDeepPropertyOf,
	getIndexOf,
	getItemByIndex,
	getPropertysValue,
	identity,
	listByNoMatch,
	map,
	matchBetweenArrays,
	matchWithProperty,
	minorAnEqualTo,
	reduce,
	setNewProperty,
	setNewPropertyByFunction,
	updateItemInCollection,
	createPropertyByOtherOne,
	validateObject,
};



// WEBPACK FOOTER //
// ./src/shared/lib.js